// Everything that differs between the Customer (t8) and Supplier (t9) portals, in one file.
//
// The two apps are otherwise line-for-line identical, and they are maintained that way deliberately:
// a fix to sign-in, the nav bar or the session belongs to both. Keeping the naming here means the
// twin file is the only thing that needs editing when they are re-synced.

// The bar renders the ParkourAI wordmark and the application name as separate pieces, the way
// the staff applications do ("ParkourAI | Developer"), so they are kept apart here.
export const BRAND = "ParkourAI";
export const APP_NAME = "Customer Portal";
// UNDER THE ROOT, BESIDE supplier. The customer portal is where a manufacturer's customers read
// everything that manufacturer releases to them -- SBOMs, lots, agreements -- so it belongs to no
// one product and sits beside the supplier portal, its inbound half.
export const DOMAIN = "customer.cres-intelligence.io";

export type Site = {
    name: string;
    description: string;
    url: string;
    current?: boolean;
};

// The site selector lists the EXTERNAL sites only.
//
// It deliberately does not mirror the staff apps' Sites Portfolio (Administration, Data Catalog,
// Foundation and the rest). Everyone standing in front of this bar is an external contact at one of
// our customers or suppliers; naming the internal tenant applications to them tells them what we run
// and invites a knock on doors they will never be let through. A customer contact who is also a
// supplier contact is the one person who needs the other entry, and they have two separate identities
// anyway -- so the link is an ordinary navigation, not a session hand-off.
export const SITES: Site[] = [
    {
        name: "Customer Portal",
        description: "Your workspace with the companies you buy from.",
        url: "https://customer.cres-intelligence.io",
        current: true,
    },
    {
        name: "Supplier Portal",
        description: "Your workspace with the companies you supply.",
        url: "https://supplier.cres-intelligence.io",
    },
];
